<template>
  <div class="animated fadeIn start-page" style="height: 100%">
    <div class="row pt-4 pb-1" style="height: 10%">
      <div class="col-12 text-center">
        <h5 style="font-weight: bold;">{{ $lang.Wellcome }}</h5>
      </div>
    </div>
    <!-- Entrada pelo SSO cujo pop-up do ZDocs o navegador bloqueou: caixa compacta no canto superior
         esquerdo da área da página inicial (10px da borda e do breadcrumb), sem cobrir o cabeçalho. -->
    <div v-if="urlZDocsPendente" class="aviso-zdocs" role="dialog" aria-label="Abrir ZDocs">
      <span>Deseja abrir o ZDocs?</span>
      <button type="button" class="btn btn-primary btn-sm" @click="abrirZDocs">Abrir</button>
      <button type="button" class="aviso-zdocs-fechar" aria-label="Fechar" @click="fecharAvisoZDocs">&times;</button>
    </div>
    <div class="row pt-1" style="height: calc(100vh - 240px);">
        <div class="col-12 logo-center">
        </div>
      </div>
  </div>
</template>

<script>
import { abrirZDocsEmNovaAba, zdocsPendente, limparZDocsPendente } from '@/shared/utils/zdocs'

export default {
  name: 'StartPage',
  data () {
    return {
      // Preenchido quando a entrada pelo SSO (screen=ZDOCS) nao conseguiu abrir a aba do ZDocs.
      urlZDocsPendente: zdocsPendente()
    }
  },
  mounted () {
    this.RemoveMinimizedSidebar()
  },
  methods: {
    abrirZDocs () {
      abrirZDocsEmNovaAba(this.urlZDocsPendente)
      this.fecharAvisoZDocs()
    },
    fecharAvisoZDocs () {
      limparZDocsPendente()
      this.urlZDocsPendente = null
    },
    RemoveMinimizedSidebar: function () {
      if (document.body.classList.length > 6) {
        document.body.classList.toggle('sidebar-minimized')
      }
    }
  }
}
</script>

<style scoped>
.start-page {
  position: relative;
}
/* 10px da borda da área de conteúdo e do breadcrumb. A raiz da StartPage começa 15px depois da
   borda (padding do container-fluid) e 16px abaixo do breadcrumb (margin dele), medido no aceite. */
.aviso-zdocs {
  position: absolute;
  top: -6px;
  left: -5px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px 6px 12px;
  background: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 4px;
  color: #0c5460;
  font-size: 13px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.aviso-zdocs-fechar {
  background: none;
  border: 0;
  padding: 0 4px;
  color: inherit;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/StartPage.vue